import {
  BatteryEmptyIcon,
  BatteryFullIcon,
  BatteryHighIcon,
  BatteryLowIcon,
  BatteryMidIcon,
} from "../assets/icons";

const getBatteryIcon = (batteryStatus) => {
  if (batteryStatus >= 0.8 && batteryStatus <= 1) {
    return <BatteryFullIcon color="#5B6D7A" alt="battery full icon" />;
  } else if (batteryStatus >= 0.6 && batteryStatus <= 0.79) {
    return <BatteryHighIcon color="#5B6D7A" alt="battery high icon" />;
  } else if (batteryStatus >= 0.4 && batteryStatus <= 0.59) {
    return <BatteryMidIcon color="#E2772E" alt="battery mid icon" />;
  } else if (batteryStatus >= 0.2 && batteryStatus <= 0.39) {
    return <BatteryLowIcon color="#E2772E" alt="battery low icon" />;
  } else if (batteryStatus >= 0 && batteryStatus <= 0.19) {
    return <BatteryEmptyIcon color="#B21515" alt="battery empty icon" />;
  }
};

// Function to validate version format
const isValidVersion = (version) => {
  return /^\d+\.\d+\.\d+$/.test(version); // Regex to check "major.minor.patch" format
};
// Function to compare versions
const isVersionNewer = (oldVer, newVer) => {
  if (
    typeof oldVer !== "string" ||
    typeof newVer !== "string" ||
    !isValidVersion(oldVer) ||
    !isValidVersion(newVer)
  )
    return false;
  const oldParts = oldVer.split(".").map(Number);
  const newParts = newVer.split(".").map(Number);

  for (let i = 0; i < 3; i++) {
    if (newParts[i] > oldParts[i]) return true;
    if (newParts[i] < oldParts[i]) return false;
  }
  return false;
};

export { getBatteryIcon, isVersionNewer };
